import React,{ Component } from 'react';
import {Row, Col, Button, Alert} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange } from "../../../../Utils";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            serversType: '',
            feed: '',
            ip: '',
            subid: '',
            device: ''
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit() {
        const isValid = this.validateForm();

        if(isValid) this.props.onSubmit({ ...this.state });
    }

    validateForm() {
        const { feed, subid, ip, serversType } = this.state;

        let alert = null;

        if(!serversType) alert = 'Please set Servers';
        else if(!feed) alert = 'Please set Feed';
        else if(!subid) alert = 'Please set Subid';
        else if(!ip) alert = 'Please set IP';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={2}>
                        <SelectWrap
                            values={{ 'adk-EU': 'EU', 'adk-US': 'US', 'adk-SG': 'SG' }}
                            label="Servers:"
                            name="serversType"
                            onChange={this.handleFieldChange}
                            value={this.state.serversType}
                            required
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Feed:"
                            name="feed"
                            onChange={this.handleFieldChange}
                            value={this.state.feed}
                            required
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="ip"
                            label="IP:"
                            onChange={this.handleFieldChange}
                            value={this.state.ip}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            name="subid"
                            label="Subid:"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={{ m: 'Mobile', d: 'Desktop' }}
                            label="Device:"
                            name="device"
                            onChange={this.handleFieldChange}
                            value={this.state.device}
                            required
                        />
                    </Col>
                </Row>

                <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Load</Button>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/AdkCalculus/components/Form/index.js